import type {GenericError, AclResponse} from 'src/types/referral-v2';
import type {Dispatch, ThunkAction} from 'src/reducers';
import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';
import {DEFAULT_ERROR} from 'src/action-creators/referral-v2/referral-jobs';


export const REFERRAL_USERS_PROGRAMS_ACCESS = 'referral/user-program-access';
export const REFERRAL_USERS_PROGRAMS_ACCESS_LOADING =
  'referral/user-program-access-loading';
export const REFERRAL_USERS_PROGRAMS_ACCESS_ERROR =
  'referral/user-program-access-error';

type ReceiveReferralUsersProgramAccessAction = {
  type: typeof REFERRAL_USERS_PROGRAMS_ACCESS;
  payload: AclResponse;
};
type ReceiveReferralUsersProgramAccessLoadingAction = {
  type: typeof REFERRAL_USERS_PROGRAMS_ACCESS_LOADING;
};
type ReceiveReferralUsersProgramAccessErrorAction = {
  type: typeof REFERRAL_USERS_PROGRAMS_ACCESS_ERROR;
  payload: GenericError | null | undefined;
};

export type ReferralAclActions =
  | ReceiveReferralUsersProgramAccessAction
  | ReceiveReferralUsersProgramAccessLoadingAction
  | ReceiveReferralUsersProgramAccessErrorAction;

const getReferralAcl = (
  payload: AclResponse,
): ReceiveReferralUsersProgramAccessAction => ({
  type: REFERRAL_USERS_PROGRAMS_ACCESS,
  payload,
});

const getReferralAclLoading =
  (): ReceiveReferralUsersProgramAccessLoadingAction => ({
    type: REFERRAL_USERS_PROGRAMS_ACCESS_LOADING,
  });

const getReferralAclError = (
  payload?: GenericError | null,
): ReceiveReferralUsersProgramAccessErrorAction => ({
  type: REFERRAL_USERS_PROGRAMS_ACCESS_ERROR,
  payload,
});

export const getReferralAclData: () => ThunkAction<void> = flow()(
  () => (dispatch: Dispatch) => {
    // @ts-expect-error - TS2769 - No overload matches this call.
    dispatch(getReferralAclLoading());
    return dispatch(reduxApi.get('referral/users/programs/access')).then(
      // @ts-expect-error - TS2345 - Argument of type '(response: AclResponse) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
      (response: AclResponse) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        dispatch(getReferralAcl(response));
      },
      (error) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        dispatch(getReferralAclError(error?.response?.errors || DEFAULT_ERROR));
      },
    );
  },
);
